<template>
  <v-container fluid grid-list-sm>
    <h3 class="headline grey--text text--darken-1 pt-3 pb-3">
      <span v-if="isList">Categories</span>
      <router-link
        v-else
        to="/category"
        class="grey--text text--darken-2 no-decoration">
        {{ $store.getters.getLangKey('categoryArchives') }}: "{{ this.id }}" ({{ pages.length }} posts)
      </router-link>
    </h3>
    <v-layout>
      <v-flex row wrap>
        <vue-adsense ad-slot="1372612451" ad-format="auto" />
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="isList">
      <v-flex xs12 sm3 lg3 v-for="(category, index) in categories" :key="index">
        <v-card>
          <v-card-actions>
            <v-btn
              router
              block
              raised
              ripple
              :style="{opacity: setOpacity(category.post_count)}"
              :color="baseColor"
              :title="category.slug"
              :to="`/category/${category.slug}`"
              class="opaque-btn cat-tag-label-btn"
              v-html="`${category.slug} (${category.post_count})`" />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else v-for="(page, index) in pages" :key="index">
      <v-flex>
        <h4 class="subheading pt-1 pb-1">
          <router-link class="grey--text text--darken-2" :to="createPostUrl(page.date, page.slug)" v-html="page.title_plain" />
        </h4>
        <p html="grey--text text--darken-2" v-html="sanitize(page.excerpt)" />
        <post-details :page="page" />
      </v-flex>
    </v-layout>
  </v-container>
  </v-container>
</template>
<script>
  import TagsList from '../components/TagsList.vue'
  import CategoriesList from '../components/CategoriesList.vue'
  import PostDetails from '../components/PostDetails.vue'
  import Mixins from '../helpers/Mixins'
  import Filters from '../helpers/Filters'

  export default {
    name: 'CategoryPage',
    mixins: [
      Mixins
    ],
    components: {
      TagsList,
      CategoriesList,
      PostDetails
    },
    data () {
      return {
        categories: this.$store.getters.categories.sort(function (a, b) {
          return b.post_count - a.post_count
        }),
        baseColor: this.$store.state.baseColor,
        isList: true,
        pages: []
      }
    },
    watch: {
      '$route.params.id': function () {
        this.getId()
      }
    },
    mounted () {
      this.getId()
    },
    methods: {
      getId () {
        this.id = this.$route.params.id
        const store = this.$store
        if (!this.id) {
          // list all categories
          this.isList = true
          this.setTitle(store.getters.getLangKey('categories'))
        } else {
          const getters = store.getters
          const base = getters.apiProxyUrl
          const resource = 'get_category_posts'
          const categorySlug = this.id
          const url = `${base}?resource=${resource}&category_slug=${categorySlug}`
          this.isList = false
          const ajax = store.state.events.ajax
          const cachedCategory = store.getters.category(this.id)
          if (cachedCategory) {
            this.pages = cachedCategory
            this.setTitle(this.id)
            return
          }
          this.$root.$emit(ajax, true)
          this.$http(url).then(response => {
            response = response.data
            if (!response) {
              this.to404()
              return
            }
            this.pages = response.posts
            this.$store.commit('setCategory', {
              slug: this.id,
              pages: this.pages
            })
            this.setTitle(response.category.title)
            this.$root.$emit(ajax, false)
          })
        }
      },
      /**
       * @using ../../filters
       */
      formatDate () {
        return Filters.formatDate()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/CategoryPage.vue